/**
 * GraphQL Module Exports
 * Central export point for all GraphQL-related functionality
 *
 * Note: Requires @apollo/client and graphql packages to be installed
 * Run: npm install @apollo/client graphql
 */

// Client
export { apolloClient } from './client';

// Config
export { graphqlConfig, getGraphQLUrl } from './config';

// Queries and Mutations
export * from './queries';
export * from './mutations';

// Re-export commonly used GraphQL utility
// Note: Import React hooks like useQuery/useMutation directly from '@apollo/client'
export { gql } from '@apollo/client';